import * as A from '../actions/ssFormActions';

export default(state = {}, action) => {
    switch (action.type) {
        case A.STORE_SS_FORM_FIELD:
            return {...state, [action.formName]: {...state[action.formName], [action.fieldName]: action.value }};

        case A.STORE_SS_FORM:
            return {...state,[action.formName]: {...state[action.formName], ...action.value }};

        case A.FORM_UTILS_MARK_FORM_FIELD_ERROR_CODE: return ((state, errorCode, formName, formField) => {
            let help = '';
            if(state.hasOwnProperty(formName) && state[formName].hasOwnProperty(formField)) 
                switch(errorCode) {
                    case 409: 
                        help = 'This Email address already exists. Please try another.';
                        break;

                    case 412: 
                        help = 'This User ID already exists.  Please try another.';
                        break;
                    case 418: 
                        help = 'This FAA Certificate already exists.';
                        break;
                    case 428: 
                        help = 'Invalid User ID. Please enter only lowercase letters and/or numbers.';
                    break;
                }

            return {...state,
                [formName]: {...state[formName],
                    [`${formField}_help`]: help,
                    [`${formField}_status`]: 'error'
                }
            };
        })(state, action.errorCode, action.formName, action.formField)

        case A.TOGGLE_REQUIRED_FORM_FIELD: return ((state, form, field) => {
            return {...state};
        })(state, action.payload.form, action.payload.field)

        case A.RESET_SS_FORM_DATA: return {};

        default: return {...state};
    }
}
